// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
const makeOnEnterKeyHandler = callback =>
  function(event) {
    if (event.key === 'Enter') {
      return callback()
    }
  }


const makeOnCommandEnterKeyHandler = callback =>
  function(event) {
    if ((event.key === 'Enter') && event.getModifierState('Meta')) {
      return callback()
    }
  }


export { makeOnEnterKeyHandler, makeOnCommandEnterKeyHandler }



// WEBPACK FOOTER //
// ./src/scripts/utils/FormHelpers.js